export default "__VITE_ASSET__C23s0IRi__"